<template>
    <div
        v-b-tooltip.hover.right="{ container: 'vue-app', variant: currentIconStyles['variant'] }"
        :title="params.data.reservation.state.name"
        :style="{ ...currentIconStyles }"
        class="reservation-status-marker"
    ></div>
</template>


<script>
import {
    RESERVATION_STATUS_PAID,
    RESERVATION_STATUS_PAIDDEPOSIT,
    RESERVATION_STATUS_NOTPAID,
    RESERVATION_STATUS_CANCELLED,
    RESERVATION_STATUS_BLOCKED,
} from '../../../../constants';
export default {
    name: 'StateMarkerCellRenderer',
    computed: {
        currentIconStyles() {
            switch (this.params.data.reservation.state.sysname) {
                case RESERVATION_STATUS_PAID:
                    return { background: '#090', variant: 'success', };
                case RESERVATION_STATUS_PAIDDEPOSIT:
                    return {
                        background:
                            'linear-gradient(to bottom, transparent 0%, transparent 50%, #fa0 50%, #fa0 100%)',
                        border: '2px solid #fa0',
                        variant: 'warning',
                    };
                case RESERVATION_STATUS_NOTPAID:
                    return { border: '2px solid #c00', variant: 'danger', };
                case RESERVATION_STATUS_CANCELLED:
                    return { background: '#9e9e9e', variant: 'secondary', };
                case RESERVATION_STATUS_BLOCKED:
                    return { background: '#000', variant: 'black', };
                default:
                    return { background: '#000', variant: 'black', };
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.reservation-status-marker {
    border-radius: 50%;
    width: 20px;
    height: 20px;
}
</style>